module.exports = __webpack_public_path__ + "assets/img/picture5.eafc0ffe.svg";